/* HVS Thuisbezichtiging-selectie (localStorage) */
(function(){
  'use strict';
  var I=window.HVSI18N||{};function L(k,d){return I[k]||d}
  var KEY='hvs_thuisbezichtiging_v1', PAGE=(I.root||'/')+'pages/thuisbezichtiging';
  function load(){try{return JSON.parse(localStorage.getItem(KEY))||[]}catch(e){return []}}
  function save(l){try{localStorage.setItem(KEY,JSON.stringify(l))}catch(e){} render()}
  function has(h){return load().some(function(i){return i.handle===h})}
  function sizeOf(t){var m=(t||'').match(/\d+\s*[x×]\s*\d+\s*(cm)?/i);return m?m[0].replace(/\s+/g,' ').replace(/(\d)$/,'$1 cm'):''}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  window.HVSTB={load:load,save:save,key:KEY};

  /* Header-teller */
  var icon='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"/></svg>';
  function header(){
    var n=load().length;
    var carts=document.querySelectorAll('a.navlink--cart');
    if(!document.querySelector('.hvs-tb-hdr')&&carts.length){
      carts.forEach(function(c){
        var wrap=c.parentElement; var a=document.createElement('a');
        a.href=PAGE;a.className='hvs-tb-hdr navlink';a.setAttribute('aria-label',L('hdr','Thuisbezichtiging'));
        a.innerHTML=icon+'<span class="hvs-tb-hdr__count" data-hvs-tb-count></span>';
        wrap.parentElement.insertBefore(Object.assign(document.createElement('div'),{className:(wrap.className||'')+' hvs-tb-hdr-wrap'}),wrap).appendChild(a);
      });
    }
    if(!carts.length&&!document.querySelector('.hvs-tb-float')){
      var f=document.createElement('a');f.href=PAGE;f.className='hvs-tb-float';f.innerHTML=icon+'<span data-hvs-tb-count></span>';document.body.appendChild(f);
    }
    document.querySelectorAll('.hvs-tb-hdr-wrap').forEach(function(e){e.style.display=''});
    document.querySelectorAll('.hvs-tb-float').forEach(function(e){e.style.display=n?'':'none'});
    document.querySelectorAll('[data-hvs-tb-count]').forEach(function(e){e.textContent=n;e.style.display=n?'':'none'});
  }

  /* Productpagina-knop */
  function productBtn(){
    var el=document.getElementById('hvs-tb-product'); if(!el) return;
    var p; try{p=JSON.parse(el.textContent)}catch(e){return}
    p.size=sizeOf(p.title);
    var btn=document.querySelector('.hvs-tb-add');
    if(!btn){
      btn=document.createElement('button');btn.type='button';btn.className='hvs-tb-add';
      var atc=document.querySelector('form[action*="/cart/add"] [data-add-to-cart]')||document.querySelector('form[action*="/cart/add"] button[type=submit]');
      var anchor=atc?(atc.closest('product-form')||atc.closest('form')):document.querySelector('.hvs-pdp--aivy');
      if(!anchor) return;
      anchor.parentNode.insertBefore(btn,anchor.nextSibling);
      btn.addEventListener('click',function(){
        var l=load();
        if(has(p.handle)) l=l.filter(function(i){return i.handle!==p.handle}); else l.push(p);
        save(l);
      });
    }
    var on=has(p.handle);
    btn.classList.toggle('is-added',on);
    btn.innerHTML=on?L('added','In uw thuisbezichtiging &#10003;'):L('add','Voeg toe aan thuisbezichtiging');
    btn.setAttribute('aria-pressed',on);
  }

  /* Lijst op de pagina */
  function list(){
    var root=document.querySelector('[data-hvs-tb-list]'); if(!root) return;
    if(root.hasAttribute('data-posted')){localStorage.removeItem(KEY);root.querySelector('[data-hvs-tb-thanks]').hidden=false;['[data-hvs-tb-items]','.hvs-tb__form','[data-hvs-tb-empty]'].forEach(function(s){var e=root.querySelector(s);if(e)e.hidden=true});return}
    var l=load(), box=root.querySelector('[data-hvs-tb-items]'), form=root.querySelector('.hvs-tb__form'), empty=root.querySelector('[data-hvs-tb-empty]');
    empty.hidden=!!l.length; form.hidden=!l.length; box.hidden=!l.length;
    box.innerHTML=l.map(function(i,n){return '<div class="hvs-tb-card"><a class="hvs-tb-card__img" href="'+esc(i.url)+'"><img src="'+esc(i.image)+'" alt="'+esc(i.title)+'" loading="lazy"></a><div class="hvs-tb-card__info"><a class="hvs-tb-card__title" href="'+esc(i.url)+'">'+esc(i.title)+'</a>'+(i.art?'<p>'+L('art','Artikelnummer')+': <strong>'+esc(i.art)+'</strong></p>':'')+(i.size?'<p>'+L('size','Afmeting')+': '+esc(i.size)+'</p>':'')+'<button type="button" class="hvs-tb-card__rm" data-rm="'+n+'">'+L('rm','Verwijderen')+'</button></div></div>'}).join('');
    box.querySelectorAll('[data-rm]').forEach(function(b){b.onclick=function(){var x=load();x.splice(+b.getAttribute('data-rm'),1);save(x)}});
    var txt=l.map(function(i){return '- '+(i.art?'Art.nr. '+i.art+' – ':'')+i.title+' – '+i.url}).join('\n');
    var f=root.querySelector('[name="contact[Geselecteerde kleden]"]'); if(f) f.value=txt;
    var m=root.querySelector('[data-hvs-tb-mailto]'); if(m) m.href='mailto:info@kelim.nl?subject='+encodeURIComponent('Thuisbezichtiging')+'&body='+encodeURIComponent('Artikelnummers:\n'+txt+'\n\nNaam:\nTelefoon:\nPlaats/postcode:\nVoorkeursdatum:\n');
    var c=root.querySelector('[data-hvs-tb-n]'); if(c) c.textContent=l.length;
  }
  /* Calendly (link van live site: individuele-afspraak) */
  var CAL='https://calendly.com/hammingvanseventer/individuele-afspraak';
  function calUrl(){
    var root=document.querySelector('[data-hvs-tb-list]'); var l=load();
    var q=function(n){var e=root&&root.querySelector('[name="contact['+n+']"]');return e?e.value.trim():''};
    var arts=l.map(function(i){return (i.art?i.art+' ':'')+'('+i.title+')'}).join(', ');
    var p=[];
    if(q('name'))p.push('name='+encodeURIComponent(q('name')));
    if(q('email'))p.push('email='+encodeURIComponent(q('email')));
    if(arts)p.push('a1='+encodeURIComponent('Thuisbezichtiging – artikelnummers: '+arts));
    p.push('utm_source=kelim.nl','utm_medium=thuisbezichtiging');
    return CAL+'?'+p.join('&');
  }
  function calendly(){
    var b=document.querySelector('[data-hvs-tb-calendly]'); if(!b||b._hvs) return; b._hvs=1;
    var upd=function(){b.href=calUrl()}; upd();
    document.addEventListener('input',function(e){if(e.target.closest&&e.target.closest('[data-hvs-tb-list]'))upd()});
    b.addEventListener('click',function(ev){
      ev.preventDefault(); var url=calUrl();
      var go=function(){window.Calendly.initPopupWidget({url:url})};
      if(window.Calendly) return go();
      var c=document.createElement('link');c.rel='stylesheet';c.href='https://assets.calendly.com/assets/external/widget.css';document.head.appendChild(c);
      var s=document.createElement('script');s.src='https://assets.calendly.com/assets/external/widget.js';s.async=true;
      s.onload=go;s.onerror=function(){window.open(url,'_blank','noopener')};document.head.appendChild(s);
    });
  }
  function render(){header();productBtn();list();calendly()}
  window.addEventListener('storage',render);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render);else render();
})();
